module.exports = __webpack_public_path__ + "static/media/kids_43.4f8613dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kids/JPEG/kids_43.jpg
// module id = 5899
// module chunks = 0